<ng-template #forgotPasswordModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Forgot Your Password</h4>
        <button type="button" id="" class="btn-close" aria-label="Close" title="Close Modal" (click)="modal.dismiss('Cross click');formReset()"></button>

    </div>
    <div class="modal-body">
        <form [formGroup]="formGroup" (keydown)="enterKeyPress($event)">

        <h5 class="modal-info-text light">If there is an email matching and account registered with us, we will send you
            the
            instruction how to recover your
            password</h5>
        <div class="row modal-form-row">
            <div class="col-12">
                <div>
                    <app-input [inputType]="'email'" [fieldValue]="email" [fieldText]="'email'" [fControl]="formGroup.controls['Email']" [inputClass]="'form-control'" [inputPlaceholder]="'Enter Email'" [inputLabel]="'Email'" [labelClass]="'form-label'" (onTextChange)="onTextValueChange($event)" [patternValidationMsg]="'Email is invalid'"></app-input>
                </div>
            </div>
        </div>
        <div class="btn-grps">  

            <app-button [btnText]="'Get OTP'" [btnTitle]="'Get OTP'" [btnCss]="'btn btn-primary w-100 btn-lg'" [isDisable]="isDisableGetOTPBtn" (onBtnClick)="openEmailConfirmationModal($event,emailConfirmationComponent.emailconfirmationTemplate);"></app-button>
       
            <app-button [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-text w-100 btn-md'" (onBtnClick)="modal.dismiss('Cross click');formReset()"></app-button>

        </div>
        </form>
    </div>
</ng-template>

<app-emailconfirmation #emailConfirmationModal [modalReference]="modalRef"></app-emailconfirmation>
